/**
 * RegistroCompra GraphQL Queries
 * Queries reales del backend de FinancialService
 */

/**
 * Query para obtener todos los registros de compra
 * Incluye información básica para listados
 * [Refactorizado]
 */
export const GET_ALL_REGISTRO_COMPRA = `
  query {
    getAllRegistroCompra {
      id
      hasDocument
      proveedor {
        id
        nombreProveedor
        razonSocial
      }
      nroSerie
      tipoOrden
      fechaContabilizacion
      fechaEmision
      fechaVencimiento
      tipoDocumento
      nroDocumento
      nroDeposito
      listaOS {
        id
        numberFile
        numberOS
      }
      listaOC {
        id
        numeroOC
      }
      centroCosto
      monto
      createdAt
    }
  }
`;

/**
 * Query para obtener un registro de compra por ID
 * Incluye todos los campos para edición/visualización
 * [Refactorizado]
 */
export const GET_REGISTRO_COMPRA_BY_ID = `
  query GetRegistroCompraById($id: String!) {
    getRegistroCompraById(id: $id) {
      id
      fechaRecepcion
      numeroRC
      fechaContabilizacion
      fechaEmision
      fechaVencimiento
      dias
      observaciones
      detraccion
      hasDocument
      fechaDeposito
      nroDeposito
      codigoDetraccion
      tipoDocumento
      nroDocumento
      nroSerie
      centroCosto
      moneda
      monto
      tipoOrden
      estado
      createdAt
      updatedAt
      notaCredito {
        tipoDocumento
        nroSerie
        nroDocumento
        fechaOrigen
      }
      baseImponible {
        BaseImponibleMoneda
        igvPorcentage
        afectoSoles
        afectoDolares
        confirmIGV
        igvSoles
        igvDolares
        incomeTaxWithholdingEnabled
        incomeTaxWithholdingRateType
        incomeTaxWithholdingRate
        incomeTaxWithholdingPEN
        incomeTaxWithholdingUSD
        inafectoSoles
        inafectoDolares
        exoneradoSoles
        exoneradoDolares
        tipoCambioVenta
        montoTotalSoles
        montoTotalDolares
        netPayablePEN
        netPayableUSD
      }
      listaOC {
        id
        createdAt
        updatedAt
        fechaRegistro
        tipoOC
        tipoEgreso
        categoriaEgreso
        numeroOC
        fechaPago
        moneda
        montoPagar
        appliedAmount
        observaciones
        estado
        proveedor {
          id
          nombreProveedor
          cuentaCorriente
          cuentaCorrienteSoles
          cuentaCorrienteDolares
          saldoSoles
          saldoDolares
          numRUC
          dni
          razonSocial
          condicion
          tipoPersona
          estadoProveedor
          direccion
          ciudad
          urbanizacion
          distrito
          provincia
          departamento
          pais
          ubigeo
          condicionPago
          dias
          tipoMacropago
          categoria
          subcategoria
        }
      }
      listaOS {
        id
        monedaTarifa
        idRegistro
        idItinerary
        idTicket
        numberOS
        nameEmpresa
        nameClient
        numberFile
        fileExtend
        group
        nameProveedor
        razonSocialProveedor
        codigoReserva
        fechaProceso
        fechaPago
        tipoItinerario
        subTotal
        igv
        totalGeneral
        appliedAmount
        estadoOS
        createdAt
        updatedAt
        tipoProveedor
        usuario
      }
      proveedor {
        id
        nombreProveedor
        cuentaCorriente
        cuentaCorrienteSoles
        cuentaCorrienteDolares
        saldoSoles
        saldoDolares
        numRUC
        dni
        razonSocial
        condicion
        tipoPersona
        estadoProveedor
        direccion
        ciudad
        urbanizacion
        distrito
        provincia
        departamento
        pais
        ubigeo
        condicionPago
        dias
        tipoMacropago
        categoria
        subcategoria
      }
      proveedorDestinatario {
        id
        nombreProveedor
        razonSocial
        numRUC
      }
    }
  }
`;

/**
 * Query para validar vínculo de Orden de Compra con Registro de Compra
 * [Refactorizado]
 */
export const VALIDATE_VINCULO_BY_ORDEN_COMPRA_ID = `
  query validarVinculoByOrdenCompraId($idVinculado: String!) {
    validarVinculoByOrdenCompraId(idVinculado: $idVinculado) {
      vinculado
      idVinculado
    }
  }
`;
export const GET_ORDER_ALLOCATION_SUMMARIES = `
  query GetOrderAllocationSummaries($orderType: String!, $orderIds: [String!]!) {
    getOrderAllocationSummaries(orderType: $orderType, orderIds: $orderIds) {
      orderId
      consumedAmount
    }
  }
`;
